/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Specification for creating/onboarding a new account
 */
export interface CloudCostMgmtAccountCreateSpec { 
    /**
     * AWS Account ID (12 digits)
     */
    account_id: string;
    /**
     * Organization ID (UUID)
     */
    org_id?: string;
    /**
     * Organization name
     */
    org_name?: string;
    /**
     * Enable or disable cleanup for this account (default true)
     */
    cleanup_enabled?: boolean;
}

